export enum ColumnType {
  YesNo,
  Text,
  Number,
}
